export default {
  default: () => import("/usr/src/rt-details-2023/layouts/default.vue").then(m => m.default || m)
}